import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import { Comment } from 'components/CollaborationDrawer/Comment'
import Styles from './CollaborationList.module.scss'
import { Fragment } from 'react'
import { Separator } from 'components/Menu/Separator'
import { CollabItemType } from 'stores/DocStore.types'
import { Comment as CommentType } from 'types'
import { Text } from 'blaze-ui/Text/Text'
import { baseFilters } from 'stores/CollabItemsFilters'
import { values } from 'mobx'

export const CollaborationList = observer(() => {
  const docStore = useDocStore()
  const commentCollabItems = docStore.orderedFilteredCollabItems.filter((item) => item.type === CollabItemType.Comment)

  const filtersCount = values(docStore.filters.activeKeys).filter(
    (item) => !baseFilters.map((baseFilter) => baseFilter.key).includes(item),
  ).length

  if (commentCollabItems.length === 0)
    return (
      <div className={Styles.emptyContainer}>
        <Text variant="largeList" color="var(--dark-40)">
          {filtersCount === 0 ? 'No Comments on this file yet' : 'Try removing any filter'}
        </Text>
      </div>
    )

  return (
    <ul className={Styles.list}>
      {commentCollabItems.map((collabItem, index) => (
        <Fragment key={(collabItem?.item as CommentType).id}>
          {index > 0 && <Separator />}
          <li>
            <Comment comment={collabItem.item as CommentType} />
          </li>
        </Fragment>
      ))}
    </ul>
  )
})
